import { GetterTree } from 'vuex'
import { ElectricityInstallationState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ElectricityInstallationState, RootState> = {
}
